import InputColor from 'react-input-color'

interface FamilyAutocompleteProps {
  inputName: string
  initialValue: string
  handleInputChange: (inputName: string, value: any) => void
}

function ColorPicker({ inputName, initialValue, handleInputChange }: FamilyAutocompleteProps) {
  const handleColorChange = (color: string) => {
    handleInputChange(inputName, color)
  }

  return <InputColor placement="bottom" initialValue={initialValue} onChange={(color: any) => handleColorChange(color)} />
}

export default ColorPicker
